module.exports = __webpack_public_path__ + "assets/oscar-1f6b8eb7d9d0f54846639976f43fc078.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/oscar.jpg
// module id = 519
// module chunks = 1